import { render, staticRenderFns } from "./lltlastrela.vue?vue&type=template&id=7b9463fb&scoped=true&"
import script from "./lltlastrela.vue?vue&type=script&lang=js&"
export * from "./lltlastrela.vue?vue&type=script&lang=js&"
import style0 from "./lltlastrela.vue?vue&type=style&index=0&id=7b9463fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9463fb",
  null
  
)

export default component.exports